import { BundleStatus, ContractStatus } from '../constants';

export function useContractStatus() {
    const statusClass = (status: ContractStatus | BundleStatus) => {
        switch (status) {
            case ContractStatus.Active:
                return 'bg-green-700';
            case ContractStatus.Draft:
                return 'bg-primary-700';
            case ContractStatus.Negotiate:
                return 'bg-orange-500';
            case ContractStatus.Request:
            case ContractStatus.Revise:
            case ContractStatus.Reactivate:
            case ContractStatus.Extend:
                return 'bg-teal-700';
            case ContractStatus.Signed:
                return 'bg-blue-700';
            case ContractStatus.Rejected:
            case ContractStatus.Declined:
            case ContractStatus.Withdrawn:
                return 'bg-red-700';
            case ContractStatus.Expired:
                return 'bg-orange-700';
            default:
                return 'bg-primary-700';
        }
    };

    return { statusClass };
}
